function goBottom() {
  window.scrollTo({
    top: 10000,
    behavior: 'smooth'
  })
}
export function contactUs() {
  goBottom()
}

export function goHome() {
  goBottom()
  this.$router.push({
    path: '/'
  })
}
